import { getSandboxId } from './urlParams'

function storageKey(key: string): string {
    const id = getSandboxId()
    return id ? `sb_${id}_${key}` : key
}

export function getItem(key: string): string | null {
    return localStorage.getItem(storageKey(key))
}

export function setItem(key: string, value: string): void {
    localStorage.setItem(storageKey(key), value)
}

export function removeItem(key: string): void {
    localStorage.removeItem(storageKey(key))
}
